import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LoadingContainer } from "../../components/LoadingContainer";
import { createHelpSessionApi } from "../../api/helpApi";
import { HELP_SITE_URL } from "../../constants/api";
import { isAllowedHelpRedirect } from "../../utils/helpSite";

export const HelpSessionView = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [failed, setFailed] = useState(false);
  const redirect = searchParams.get("redirect");

  useEffect(() => {
    createHelpSessionApi()
      .then(() => {
        window.location.replace(
          isAllowedHelpRedirect(redirect) ? redirect : HELP_SITE_URL,
        );
      })
      .catch((error: unknown) => {
        console.error("Could not create help session", error);
        setFailed(true);
      });
  }, [redirect]);

  return (
    <LoadingContainer
      message={failed ? t("help.sessionFailed") : t("help.openingHelp")}
    />
  );
};
